<template>
  <div class="businessDemo">
    <div class="fast_trading" v-if="fastShow">
      <div class="fast_sell bgdown shadow-down cursor" @click="fastSell">
        {{ $t("trade.text146") }} {{ offerData[0] }}{{ offerData[1] }}
      </div>
      <div class="fast_value">
        <el-input type="text" size="small" v-model="data.handCount">
          <template #prepend>
            <div class="fuhao jian cursor" @click="reduce('handCount')">-</div>
          </template>
          <template #suffix>
            <div class="fuhao cursor" @click="add('handCount')">+</div>
          </template>
        </el-input>
      </div>
      <div class="fast_buy bgup shadow-up cursor" @click="fastBuy">
        {{ $t("trade.text145") }} {{ bidData[0] }}{{ bidData[1] }}
      </div>
    </div>
    <div class="fast_trading2" v-else>
      <i class="iconfont icon-icon_del" @click="fastClose"></i>
      <div class="business_btn">
        <div :class="[
          'business_btn_sell',
          nowOption == 'buy' ? '' : 'bgdown shadow-down active_btn',
        ]" @click="changeOption('sell')">
          <div class="business_btn_buy_text">{{ $t("trade.text32") }}</div>
          <div class="business_btn_buy_value">
            {{ offerData[0] }}<span>{{ offerData[1] }}</span>
          </div>
        </div>
        <div :class="[
          'business_btn_buy',
          nowOption == 'buy' ? 'bgup shadow-up active_btn' : '',
        ]" @click="changeOption('buy')">
          <div class="business_btn_buy_text">{{ $t("trade.text30") }}</div>
          <div class="business_btn_buy_value">
            {{ bidData[0] }}<span>{{ bidData[1] }}</span>
          </div>
        </div>
      </div>
      <div class="business_form">
        <div class="business_form_item_mode">
          <div class="business_form_item_lable">{{ $t("trade.text116") }}</div>
          <div class="business_form_item_value">
            <el-radio-group name="radioGroup" v-model="traMode" @change="traModeChange">
              <el-radio value="1">
                {{ $t("trade.text117") }}
              </el-radio>
              <el-radio value="2">
                {{ $t("trade.text118") }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="business_form_item" v-show="traMode == 2">
          <div class="business_form_item_lable">{{ $t("trade.text120") }}</div>
          <div class="business_form_item_value">
            <div>
              <el-input @input="realTime"  v-model="data.listPrice" size="default">
                <template #suffix>
                  <div class="fuhao jian cursor" @click="reduce('listPrice')">
                    -
                  </div>
                  <div class="hr"></div>
                  <div class="fuhao cursor" @click="add('listPrice')">+</div>
                </template>
                <!-- <template #prefix>
                        <div class="fuhao cursor" @click="reduce('listPrice')">-</div>
                    </template>
                    <template #suffix>
                      <div  class="fuhao cursor" @click="add('listPrice')">+</div>
                    </template> -->
              </el-input>
            </div>
            <div class="business_form_item_value_bottom">
              {{ $t("trade.text96") }}&le;{{ listPriceMin }}
              {{ $t("trade.text97") }}{{ $t("trade.text96") }}&ge;{{
                listPriceMax
              }}
            </div>
          </div>
        </div>
        <div class="business_form_item">
          <div class="business_form_item_lable">{{ $t("trade.text119") }}</div>
          <div class="business_form_item_value">
            <div>
              <el-input size="default" style="font-weight: bold" @input="handCountInput"
                @blur="handCountCheck" v-model="data.handCount">
                <template #suffix>
                  <div class="fuhao jian cursor" @click="reduce('handCount')">
                    -
                  </div>
                  <div class="hr"></div>
                  <div class="fuhao cursor" @click="add('handCount')">+</div>
                </template>
              </el-input>
            </div>
            <div class="business_form_item_value_bottom">
              {{ $t("trade.text88") }} ${{ deposit }}
            </div>
          </div>
        </div>
        <div class="business_form_item" v-show="traMode == 2">
          <div class="business_form_item_lable">{{ $t("trade.text59") }}</div>
          <div class="business_form_item_value">
            <div>
              <el-input @input="stopLossInput" v-model="data.stopLoss" size="default">
                <template #suffix>
                  <div class="fuhao jian cursor" @click="reduce('stopLoss')">
                    -
                  </div>
                  <div class="hr"></div>
                  <div class="fuhao cursor" @click="add('stopLoss')">+</div>
                </template>
              </el-input>
            </div>
            <div class="business_form_item_value_bottom business_form_item_value_estimated">
              <div>
                {{ $t("trade.text96") }}{{ nowOption == "buy" ? "≤" : "≥"
                }}{{ stopLosstEdge }}
              </div>
              <div v-show="estimatedLoss">
                {{ $t("trade.text99") }}: ${{ estimatedLoss }}
              </div>
            </div>
          </div>
        </div>
        <div class="business_form_item" v-show="traMode == 2">
          <div class="business_form_item_lable">{{ $t("trade.text58") }}</div>
          <div class="business_form_item_value">
            <div>
              <el-input @input="stopProfitInput" v-model="data.stopProfit" size="default">
                <template #suffix>
                  <div class="fuhao jian cursor" @click="reduce('stopProfit')">
                    -
                  </div>
                  <div class="hr"></div>
                  <div class="fuhao cursor" @click="add('stopProfit')">+</div>
                </template>
              </el-input>
            </div>
            <div class="business_form_item_value_bottom business_form_item_value_estimated">
              <div>
                {{ $t("trade.text96") }}{{ nowOption == "buy" ? "≥" : "≤"
                }}{{ stopProfitEdge }}
              </div>
              <div v-show="estimatedProfit">
                {{ $t("trade.text98") }}: ${{ estimatedProfit }}
              </div>
            </div>
          </div>
        </div>
        <div class="business_form_item" v-show="traMode == 2">
          <div class="business_form_item_lable order_expiry_time">
            {{ $t("trade.text90") }}
          </div>
          <div class="business_form_item_value">
            <div>
              <el-date-picker popper-class="date_picker" value-format="YYYYMMDDHHmmss" :disabledDate="setFulltime"
                v-model="data.date" size="default" type="datetime" placeholder="" :teleported="false">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="determine">
          <el-button :disabled="openStatus == 0 && userToken != ''" type="primary" @click="confirm">
            {{
              userToken != ""
                ? openStatus == 0
                  ? $t("trade.text121")
                  : $t("trade.text73")
                : $t("trade.text67")
            }}
          </el-button>
        </div>
      </div>
    </div>

    <div>
      <el-dialog :show-close="false" :close-on-click-modal="false" v-model="orderVisible" width="340px"
        custom-class="order_modal" :title="instantTrading != 1 || tradeToken == ''
          ? $t('trade.text122_1')
          : $t('trade.text144')
          " destroy-on-close>
        <div class="form_item">
          <div class="form_item_lable">{{ $t("trade.text123") }}:</div>
          <div class="form_item_value">{{ activeSymbol.symbol }}</div>
        </div>
        <div class="form_item">
          <div class="form_item_lable">{{ $t("trade.text119") }}:</div>
          <div class="form_item_value">{{ data.handCount }}</div>
        </div>
        <div class="form_item">
          <div class="form_item_lable">{{ $t("trade.text88") }}:</div>
          <div class="form_item_value">{{ deposit }}</div>
        </div>
        <template #footer>
          <span class="confirm">
            <el-button @click="orderVisibleClose">{{
              $t("trade.text72")
            }}</el-button>
           <el-button type="primary" :loading="loading" @click="confirmTransaction">{{ $t("trade.text73")
              }}</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <ChangeTradingPassword />
    <SetTradingPassword />
  </div>
</template>
<script>
import {
  ref,
  reactive,
  computed,
  inject,
  onMounted,
  nextTick,
  onBeforeUnmount,
} from "vue";
import moment from "moment";
import apiServer from "@/api/request";
import { useStore } from "vuex";
import * as math from "mathjs";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";

export default {
  name: "businessPage",
  components: {},
  setup() {
    const { t } = useI18n();

    const emitt = inject("emitt");
    const store = useStore();
    const router = useRouter();
    const data = reactive({
      handCount: "",
      date: "",
      stopProfit: "",
      stopLoss: "",
      listPrice: "",
    });
    const orderVisible = ref(false);
    const activeSymbol = computed({
      get: () => store.state.home.activeSymbolItem,
    });
    const openStatus = computed({
      get: () => store.state.home.activeSymbolItem.openStatus,
    }); // 0 未开盘 1 开盘
    let decimalPlace = Number(activeSymbol.value.decimalPlace); // 小数位数
    const traMode = ref("1"); // 交易方式  1.市价 2.挂单
    const nowOption = ref("buy");
    const offerData = ref([]); // 卖价
    const bidData = ref([]); // 买价
    const deposit = ref(""); // 预估占用
    const listPriceMin = ref(""); // 挂单价格小于
    const listPriceMax = ref(""); // 挂单价格大于
    const stopLosstEdge = ref(""); // 止损价格小于或大于
    const stopProfitEdge = ref(""); // 止盈价格大于或小于
    const estimatedProfit = ref(""); // 预计盈利
    const estimatedLoss = ref(""); // 预计亏损
    const instantTrading = ref("");
    const tradeToken = ref("");
    const errorText = ref("");
    const userToken = computed({ get: () => store.getters.userToken });
    const fastShow = ref(true);

    const loading = ref(false);
    const disabledDate = (current) =>
      // Can not select days before today and today
      current && current < moment().endOf("day");
    let needExchange = ""; // 计算保证金的标记
    let perMargin = ""; // 一手的保证金
    let minDis = ""; // 最小距离
    let marginConversion = ""; // 保证金转换货币信息
    let marginRate = ""; // 杠杆比例
    let hqFloat = ""; // 行情跳动点位
    let maxTradeNum = ""; // 最大交易手数
    let minTradeSize = ""; // 最小交易手数
    let lastTradeLots = ""; // 上次交易的手数
    let defaultTradeLot = ""; // 默认交易手数

    emitt.$sub("activeSymbolChange2", () => {
      buyPage();
    });
    onBeforeUnmount(() => {
      emitt.$unsub("activeSymbolChange2");
      emitt.$unsub("refreshPrice");
    });
    // 忘记密码
    function forgetPassword() {
      // orderVisible.value = false;
      openSetLoginPasswordModel();
    }
    // 修改交易密码
    function openSetLoginPasswordModel() {
      // 修改交易密码-打开弹框
      emitt.$pub("openChangeTradingPassword");
    }
    // 手数校验
    function handCountCheck() {
      if (Number(data.handCount) < Number(minTradeSize)) {
        data.handCount = Number(minTradeSize);
      }
    }
    // 手数校验
    function handCountInput(v) {
      let val = v;
      const regu = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (val[val.length - 1] != ".") {
        while (!regu.test(val) && val != "") {
          val = val.substring(0, val.length - 1);
        }
      } else if (val.indexOf(".") != val.lastIndexOf(".")) {
        val = val.substring(0, val.length - 1);
      }
      if (Number(val) > Number(maxTradeNum)) {
        val = maxTradeNum;
      }
      if (val.indexOf(".") != -1) {
        if (
          val.toString().split(".")[1].length >
          Number(minTradeSize).toString().split(".")[1].length
        ) {
          val = Number(val).toFixed(
            Number(minTradeSize).toString().split(".")[1].length
          );
        }
      }
      nextTick(() => {
        data.handCount = val;
        countDeposit();
      });
    }

    // 止盈校验
    function stopProfitInput(v) {
      let val = v;
      const regu = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (val[val.length - 1] != ".") {
        if (!regu.test(val)) {
          val = val.substring(0, val.length - 1);
        }
      } else if (val.indexOf(".") != val.lastIndexOf(".")) {
        val = val.substring(0, val.length - 1);
      }

      if (val.indexOf(".") != -1) {
        if (val.toString().split(".")[1].length > decimalPlace) {
          val = Number(val).toFixed(decimalPlace);
        }
      }
      nextTick(() => {
        data.stopProfit = val;
        countEstimatedProfitAndLoss();
      });
    }
    // 止损校验
    function stopLossInput(v) {
      let val = v;
      const regu = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (val[val.length - 1] != ".") {
        if (!regu.test(val)) {
          val = val.substring(0, val.length - 1);
        }
      } else if (val.indexOf(".") != val.lastIndexOf(".")) {
        val = val.substring(0, val.length - 1);
      }

      if (val.indexOf(".") != -1) {
        if (val.toString().split(".")[1].length > decimalPlace) {
          val = Number(val).toFixed(decimalPlace);
        }
      }

      nextTick(() => {
        data.stopLoss = val;
        countEstimatedProfitAndLoss();
      });
    }
    function realTime(v) {
      let val = v;
      const regu = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (val[val.length - 1] != ".") {
        if (!regu.test(val)) {
          val = val.substring(0, val.length - 1);
        }
      } else if (val.indexOf(".") != val.lastIndexOf(".")) {
        val = val.substring(0, val.length - 1);
      }

      if (val.indexOf(".") != -1) {
        if (val.toString().split(".")[1].length > decimalPlace) {
          val = Number(val).toFixed(decimalPlace);
        }
      }

      nextTick(() => {
        data.listPrice = val;
        countDeposit();
      });
    }
    // 买卖价强调
    function emphasizePrice(e) {
      e = e.toString();
      const arr = e.split(".");
      const priceArr = [];
      if (arr.length == 2) {
        if (arr[1].length >= 2) {
          priceArr[0] = e.substring(0, e.length - 2);
          priceArr[1] = e.substring(e.length - 2);
        } else {
          priceArr[0] = `${arr[0]}.`;
          priceArr[1] = arr[1];
        }
        return priceArr;
      }
      return [0, 0];
    }
    const tradpassword = ref("");
    function confirmTransaction() {
      console.log("confirmTransaction",userToken.value);
      simplifyOrder();
    }

    function simplifyOrder() {
      const params = {
        symbol: activeSymbol.value.symbol,
        tradetype: traMode.value == "1" ? "2" : "1",
        quantity: data.handCount,
        margin: deposit.value,
        bstype: nowOption.value == "buy" ? "1" : "2",
        usertoken: localStorage.userToken,
      };
      if (traMode.value == "2") {
        Object.assign(params, {
          price: data.listPrice,
          marketPrice:
            nowOption.value == "buy"
              ? bidData.value[0] + bidData.value[1]
              : offerData.value[0] + offerData.value[1],
          canceltime: data.date,
          takeprofit: data.stopProfit,
          stoploss: data.stopLoss,
        });
      }
      apiServer.simplifyOrderDemo(params).then((result) => {
        orderVisibleClose();
        loading.value = false;
        if (result.status == 1) {
          ElMessage({
            message: t("trade.text86"),
            type: "success",
            appendTo: ".businessDemo",
          });
          lastTradeLots = data.handCount;
        } else if (result.status == 310) {
          ElMessageBox.alert(t("trade.text125"), {
            confirmButtonText: t("trade.text84"),
            appendTo: ".businessDemo",
          }).then(() => { });
        } else if (result.status == 303) {
          ElMessageBox.alert(result.message, {
            confirmButtonText: t("trade.text73"),
            appendTo: ".businessDemo",
          }).then(() => { });
        } else {
          ElMessage({
            message: result.message,
            type: "error",
            appendTo: ".businessDemo",
          });
        }
      });
    }

    // 计算默认交易手数
    function countHandCount() {
      console.log("countHandCount");
      if (
        lastTradeLots != "" &&
        Number(lastTradeLots) >= Number(minTradeSize) &&
        Number(lastTradeLots) <= Number(maxTradeNum)
      ) {
        data.handCount = Number(Number(lastTradeLots).toFixed(
          getDecimalPlaces(Number(minTradeSize))
        ));
      } else if (defaultTradeLot != "") {
        data.handCount = Number(defaultTradeLot);
      } else {
        data.handCount = Number(minTradeSize);
      }
    }

    function getDecimalPlaces(num) {
      const str = num.toString();
      const decimalIndex = str.indexOf(".");
      if (decimalIndex !== -1) {
        return str.length - decimalIndex - 1;
      }
      return 0;
    }
    // 买入卖出切换
    function changeOption(e) {
      nowOption.value = e;
      traMode.value = "1";
      Object.assign(data, {
        handCount: "",
        date: "",
        stopProfit: "",
        stopLoss: "",
        listPrice: "",
      });
      countHandCount();
      countStopProfitRange();
      countListPriceRange();
      countListPrice();
      countDeposit();
    }

    onMounted(() => {
      if (localStorage.tradeTokenDay) {
        if (
          localStorage.tradeTokenDay !=
          new Date().getMonth() + "-" + new Date().getDate()
        ) {
          localStorage.removeItem("tradeTokenDay");
          localStorage.removeItem("tradeToken");
        }
      }
    });

    function buyPage() {
      const params = {
        symbol: activeSymbol.value.symbol,
      };
      apiServer.buyPageDemo(params).then((res) => {
        if (res.status == 1) {
          minDis = Number(res.data.minDis);
          perMargin = res.data.perMargin;
          needExchange = res.data.needExchange;
          marginConversion = res.data.marginConversion;
          marginRate = res.data.marginRate;
          hqFloat = res.data.hqFloat;
          defaultTradeLot = res.data.defaultTradeLot;
          lastTradeLots = res.data.lastTradeLots;
          minTradeSize = res.data.minTradeSize;
          maxTradeNum = res.data.maxTradeNum;
          decimalPlace = Number(activeSymbol.value.decimalPlace); // 小数位数
          data.stopProfit = "";
          data.stopLoss = "";
          data.date = "";
          estimatedProfit.value = "";
          estimatedLoss.value = "";
          offerData.value = emphasizePrice(
            printFn(
              Number(activeSymbol.value.askPrice) 
            )
          );
          bidData.value = emphasizePrice(
            printFn(
              Number(activeSymbol.value.bidPrice)
            )
          );
          countHandCount();
          countListPriceRange();
          countListPrice();
          countDeposit();
          countEstimatedProfitAndLoss();
          countStopProfitRange();
          let index = hqFloat.toString().indexOf(".");
          if (hqFloat.toString().length - 1 - index > Number(decimalPlace)) {
            hqFloat = 1 * Math.pow(10, -decimalPlace);
            console.log("hqFloat", hqFloat);
          }
          emitt.$sub("refreshPrice", (val) => {
            offerData.value = emphasizePrice(val[0].offerData);
            bidData.value = emphasizePrice(val[0].bidData);
            countListPriceRange();
            countDeposit();
            countStopProfitRange();
            countEstimatedProfitAndLoss();
          });
        }
      });
    }
    // 计算挂单价格
    function countListPrice() {
      data.listPrice = listPriceMin.value;
    }
    // 计算挂单价格范围
    function countListPriceRange() {
      if (nowOption.value == "buy") {
        listPriceMin.value = printFn(
          Number(bidData.value[0] + bidData.value[1]) - minDis
        );
        listPriceMax.value = printFn(
          Number(bidData.value[0] + bidData.value[1]) + minDis
        );
      } else {
        listPriceMin.value = printFn(
          Number(offerData.value[0] + offerData.value[1]) - minDis
        );
        listPriceMax.value = printFn(
          Number(offerData.value[0] + offerData.value[1]) + minDis
        );
      }
    }
    // 计算预估保证金
    function countDeposit() {
      if (needExchange == 0) {
        deposit.value = (data.handCount * perMargin).toFixed(2);
      } else if (needExchange == 1) {
        if (traMode.value == "1") {
          // 市价
          if (marginConversion.symbol.indexOf("USD") == 0) {
            // 转换货币在美元后面
            deposit.value = (
              (data.handCount * perMargin) /
              marginConversion.bidPrice
            ).toFixed(2);
          } else {
            // 转换货币在美元前面
            deposit.value = (
              data.handCount *
              perMargin *
              marginConversion.bidPrice
            ).toFixed(2);
          }
        } else if (traMode.value == "2") {
          // 挂单
          if (marginConversion.symbol.indexOf("USD") == 0) {
            // 转换货币在美元后面
            deposit.value = (
              (data.handCount * perMargin) /
              data.listPrice
            ).toFixed(2);
          } else {
            // 转换货币在美元前面
            deposit.value = (
              data.handCount *
              perMargin *
              data.listPrice
            ).toFixed(2);
          }
        }
      } else if (needExchange == "2") {
        if (marginConversion.symbol.indexOf("USD") == 0) {
          // 转换货币在美元后面
          deposit.value = (
            (data.handCount * perMargin) /
            marginConversion.bidPrice
          ).toFixed(2);
        } else {
          // 转换货币在美元前面
          deposit.value = (
            data.handCount *
            perMargin *
            marginConversion.bidPrice
          ).toFixed(2);
        }
      } else if (needExchange == "3") {
        if (traMode.value == "1") {
          // 市价
          if (nowOption.value == "buy") {
            deposit.value = (
              data.handCount *
              perMargin *
              Number(bidData.value[0] + bidData.value[1])
            ).toFixed(2);
          } else {
            deposit.value = (
              data.handCount *
              perMargin *
              Number(offerData.value[0] + offerData.value[1])
            ).toFixed(2);
          }
        } else {
          // 挂单
          deposit.value = (
            data.handCount *
            perMargin *
            Number(data.listPrice)
          ).toFixed(2);
        }
      } else if (needExchange == "4") {
        if (traMode.value == "1") {
          // 市价
          if (nowOption.value == "buy") {
            if (marginConversion.symbol.indexOf("USD") == 0) {
              // 转换货币在美元后面
              deposit.value = (
                (data.handCount *
                  perMargin *
                  Number(bidData.value[0] + bidData.value[1])) /
                marginConversion.bidPrice
              ).toFixed(2);
            } else {
              // 转换货币在美元前面
              deposit.value = (
                data.handCount *
                perMargin *
                Number(bidData.value[0] + bidData.value[1]) *
                marginConversion.bidPrice
              ).toFixed(2);
            }
          } else if (marginConversion.symbol.indexOf("USD") == 0) {
            // 转换货币在美元后面
            deposit.value = (
              (data.handCount *
                perMargin *
                Number(offerData.value[0] + offerData.value[1])) /
              marginConversion.bidPrice
            ).toFixed(2);
          } else {
            // 转换货币在美元前面
            deposit.value = (
              data.handCount *
              perMargin *
              Number(offerData.value[0] + offerData.value[1]) *
              marginConversion.bidPrice
            ).toFixed(2);
          }
        } else {
          // 挂单
          if (marginConversion.symbol.indexOf("USD") == 0) {
            // 转换货币在美元后面
            deposit.value = (
              (data.handCount * perMargin * Number(data.listPrice)) /
              marginConversion.bidPrice
            ).toFixed(2);
          } else {
            // 转换货币在美元前面
            deposit.value = (
              data.handCount *
              perMargin *
              Number(data.listPrice) *
              marginConversion.bidPrice
            ).toFixed(2);
          }
        }
      }
    }
    // 计算止盈止损价格范围
    function countStopProfitRange() {
      if (traMode.value == "1") {
        // 市价
        if (nowOption.value == "buy") {
          // 如果是买，止盈价格 >= 当前卖价+mindis； 止损价格<= 当前卖价-mindis
          stopProfitEdge.value = printFn(
            Number(offerData.value[0] + offerData.value[1]) + minDis
          );
          stopLosstEdge.value = printFn(
            Number(offerData.value[0] + offerData.value[1]) - minDis
          );
        } else {
          // 如果是卖，止盈价格 <= 当前买价-mindis； 止损价格 >= 当前买价+mindis
          stopProfitEdge.value = printFn(
            Number(bidData.value[0] + bidData.value[1]) - minDis
          );
          stopLosstEdge.value = printFn(
            Number(bidData.value[0] + bidData.value[1]) + minDis
          );
        }
      } else {
        // 挂单
        if (nowOption.value == "buy") {
          // 如果是买 止盈价格 >= 挂单价+mindis； 止损价格<= 挂单价-mindis
          stopProfitEdge.value = printFn(
            Number(data.listPrice) + Number(minDis)
          );
          stopLosstEdge.value = printFn(
            Number(data.listPrice) - Number(minDis)
          );
        } else {
          // 如果是卖，止盈价格 <= 当前买价-mindis； 止损价格 >= 当前买价+mindis
          stopProfitEdge.value = printFn(Number(data.listPrice) - minDis);
          stopLosstEdge.value = printFn(Number(data.listPrice) + minDis);
        }
      }
    }
    // 计算预计盈利和预计亏损
    function countEstimatedProfitAndLoss() {
      if (data.stopProfit == "") {
        estimatedProfit.value = "";
      }
      if (data.stopLoss == "") {
        estimatedLoss.value = "";
      }
      if (traMode.value == "1") {
        // 市价
        if (nowOption.value == "buy") {
          if (data.stopProfit != "") {
            // 预计收益=保证金/杠杆比例*（止盈价-买价）/买价  （保留两位小数点
            estimatedProfit.value = (
              ((deposit.value / marginRate) *
                (Number(data.stopProfit) -
                  Number(bidData.value[0] + bidData.value[1]))) /
              Number(bidData.value[0] + bidData.value[1])
            ).toFixed(2);
          }
          if (data.stopLoss != "") {
            // 可能亏损=保证金/杠杆比例*（止损价-买价）/买价   （保留两位小数点）
            estimatedLoss.value = (
              ((deposit.value / marginRate) *
                (Number(data.stopLoss) -
                  Number(bidData.value[0] + bidData.value[1]))) /
              Number(bidData.value[0] + bidData.value[1])
            ).toFixed(2);
          }
        } else {
          if (data.stopProfit != "") {
            // 预计收益=保证金/杠杆比例*（卖价-止盈价）/卖价   （保留两位小数点）
            estimatedProfit.value = (
              ((deposit.value / marginRate) *
                (Number(offerData.value[0] + offerData.value[1]) -
                  Number(data.stopProfit))) /
              Number(offerData.value[0] + offerData.value[1])
            ).toFixed(2);
          }
          if (data.stopLoss != "") {
            // 可能亏损=保证金/杠杆比例*（卖价-止损价）/卖价     （保留两位小数点）
            estimatedLoss.value = (
              ((deposit.value / marginRate) *
                (Number(offerData.value[0] + offerData.value[1]) -
                  Number(data.stopLoss))) /
              Number(offerData.value[0] + offerData.value[1])
            ).toFixed(2);
          }
        }
      } else if (traMode.value == "2") {
        // 挂单
        if (nowOption.value == "buy") {
          if (data.stopProfit != "") {
            // 预计收益=保证金/杠杆比例*（止盈价-挂单价）/挂单价  （保留两位小数点）
            estimatedProfit.value = (
              ((deposit.value / marginRate) *
                (Number(data.stopProfit) - Number(data.listPrice))) /
              Number(data.listPrice)
            ).toFixed(2);
          }
          if (data.stopLoss != "") {
            // 可能亏损=保证金/杠杆比例*（止损价-挂单价）/挂单价    （保留两位小数点）
            estimatedLoss.value = (
              ((deposit.value / marginRate) *
                (Number(data.stopLoss) - Number(data.listPrice))) /
              Number(data.listPrice)
            ).toFixed(2);
          }
        } else {
          if (data.stopProfit != "") {
            // 预计收益=保证金/杠杆比例*（挂单价-止盈价）/卖价       （保留两位小数点）
            estimatedProfit.value = (
              ((deposit.value / marginRate) *
                (Number(data.listPrice) - Number(data.stopProfit))) /
              Number(offerData.value[0] + offerData.value[1])
            ).toFixed(2);
          }
          if (data.stopLoss != "") {
            // 可能亏损=保证金/杠杆比例*（挂单价-止损价）/卖价     （保留两位小数点）
            estimatedLoss.value = (
              ((deposit.value / marginRate) *
                (Number(data.listPrice) - Number(data.stopLoss))) /
              Number(offerData.value[0] + offerData.value[1])
            ).toFixed(2);
          }
        }
      }
    }

    function reduce(e) {
      switch (e) {
        case "listPrice":
          data.listPrice = printFn(Number(data.listPrice) - Number(hqFloat));
          break;
        case "handCount":
          if (Number(data.handCount) <= Number(minTradeSize)) {
            ElMessage({
              message: `${t("trade.text129")} ${minTradeSize}`,
              type: "error",
              appendTo: ".businessDemo",
            });
            return;
          }
          data.handCount = ensureAccuracy(
            Number(data.handCount) - Number(minTradeSize)
          );
          countDeposit();
          break;
        case "stopProfit":
          if (data.stopProfit == "" || data.stopProfit == "--") {
            data.stopProfit = stopProfitEdge.value;
          }
          if (nowOption.value == "buy") {
            if (
              printFn(Number(data.stopProfit) - Number(hqFloat)) <
              Number(stopProfitEdge.value)
            ) {
              data.stopProfit = stopProfitEdge.value;
              return;
            }
          } else if (printFn(Number(data.stopProfit) - Number(hqFloat)) < 0)
            return;
          data.stopProfit = printFn(Number(data.stopProfit) - Number(hqFloat));
          break;
        case "stopLoss":
          if (data.stopLoss == "" || data.stopLoss == "--") {
            data.stopLoss = stopLosstEdge.value;
          }
          if (nowOption.value == "buy") {
            if (printFn(Number(data.stopLoss) - Number(hqFloat)) <= 0) return;
          } else if (
            printFn(Number(data.stopLoss) - Number(hqFloat)) <
            Number(stopLosstEdge.value)
          ) {
            data.stopLoss = stopLosstEdge.value;
            return;
          }
          data.stopLoss = printFn(Number(data.stopLoss) - Number(hqFloat));
          break;
      }
      countEstimatedProfitAndLoss();
    }
    function add(e) {
      switch (e) {
        case "listPrice":
          data.listPrice = printFn(Number(data.listPrice) + Number(hqFloat));
          break;
        case "handCount":
          if (Number(data.handCount) >= Number(maxTradeNum)) {
            ElMessage({
              message: `${t("trade.text130")} ${maxTradeNum}`,
              type: "error",
              appendTo: ".businessDemo",
            });
            return;
          }
          data.handCount = ensureAccuracy(
            Number(data.handCount) + Number(minTradeSize)
          );
          countDeposit();
          break;
        case "stopProfit":
          if (data.stopProfit == "" || data.stopProfit == "--") {
            data.stopProfit = stopProfitEdge.value;
          }
          if (nowOption.value != "buy") {
            if (
              printFn(Number(data.stopProfit) + Number(hqFloat)) >
              Number(stopProfitEdge.value)
            ) {
              data.stopProfit = stopProfitEdge.value;
              return;
            }
          }
          data.stopProfit = printFn(Number(data.stopProfit) + Number(hqFloat));
          break;
        case "stopLoss":
          if (data.stopLoss == "" || data.stopLoss == "--") {
            data.stopLoss = stopLosstEdge.value;
          }
          if (nowOption.value == "buy") {
            if (
              printFn(Number(data.stopLoss) + Number(hqFloat)) >
              Number(stopLosstEdge.value)
            ) {
              data.stopLoss = stopLosstEdge.value;
              return;
            }
          }
          data.stopLoss = printFn(Number(data.stopLoss) + Number(hqFloat));
          break;
      }
      countEstimatedProfitAndLoss();
    }
    // 指定保留小数位
    function printFn(value) {
      const v = Number(value).toFixed(decimalPlace);
      return v;
    }
    // 精度问题
    function ensureAccuracy(value) {
      const precision = 14;
      return Number(math.format(value, precision));
    }

    // 确定下单
    function confirm() {
      if (data.listPrice == "") {
        ElMessage.error({ message: t("trade.text131"), appendTo: ".businessDemo" });
        return;
      }
      if (traMode.value == 2) {
        if (
          Number(data.listPrice) > Number(listPriceMin.value) &&
          Number(data.listPrice) < Number(listPriceMax.value)
        ) {
          ElMessage.error({
            message: `${t("trade.text96")}<=${listPriceMin.value} ${t(
              "trade.text97"
            )} >=${listPriceMax.value}`,
            appendTo: ".businessDemo",
          });
          return;
        }
        if (nowOption.value == "buy") {
          // 如果是买
          if (
            data.stopLoss != "" &&
            Number(data.stopLoss) > Number(stopLosstEdge.value)
          ) {
            ElMessage.error({
              message: `${t("trade.text102")} <= ` + stopLosstEdge.value,
              appendTo: ".businessDemo",
            });
            return;
          }
          if (
            data.stopProfit != "" &&
            Number(data.stopProfit) < Number(stopProfitEdge.value)
          ) {
            ElMessage.error({
              message: `${t("trade.text103")} >= ` + stopProfitEdge.value,
              appendTo: ".businessDemo",
            });
            return;
          }
        } else {
          // 如果是卖
          if (
            data.stopLoss != "" &&
            Number(data.stopLoss) < Number(stopLosstEdge.value)
          ) {
            ElMessage.error({
              message: `${t("trade.text102")} >= ` + stopLosstEdge.value,
              appendTo: ".businessDemo",
            });
            return;
          }
          if (
            data.stopProfit != "" &&
            Number(data.stopProfit) > Number(stopProfitEdge.value)
          ) {
            ElMessage.error({
              message: `${t("trade.text103")} <=` + stopProfitEdge.value,
              appendTo: ".businessDemo",
            });
            return;
          }
        }
      }

      if (
        traMode.value == 1 &&
        Number(sessionStorage.freeMargin) < Number(deposit.value)
      ) {
        ElMessageBox.alert(t("trade.text125"), {
          confirmButtonText: t("trade.text84"),
          appendTo: ".businessDemo",
        })
          .then(() => {
            // router.push({ name: 'payment' });
          })
          .catch(() => { });
        return;
      }
      if (traMode.value == "2") {
        // 止损校验
        if (nowOption.value == "buy") {
          if (
            data.stopLoss != "" &&
            Number(data.stopLoss) > Number(stopLosstEdge.value)
          ) {
            ElMessage({
              message: `${t("trade.text59")}≤${stopLosstEdge.value}`,
              type: "error",
              appendTo: ".businessDemo",
            });
            return;
          }
          // 止盈校验
          if (
            data.stopProfit != "" &&
            Number(data.stopProfit) < Number(stopProfitEdge.value)
          ) {
            ElMessage({
              message: `${t("trade.text58")}≥${stopProfitEdge.value}`,
              type: "error",
              appendTo: ".businessDemo",
            });
            return;
          }
        } else {
          if (
            data.stopLoss != "" &&
            Number(data.stopLoss) < Number(stopLosstEdge.value)
          ) {
            ElMessage({
              message: `${t("trade.text59")}≥${stopLosstEdge.value}`,
              type: "error",
              appendTo: ".businessDemo",
            });
            return;
          }
          // 止盈校验
          if (
            data.stopProfit != "" &&
            Number(data.stopProfit) > Number(stopProfitEdge.value)
          ) {
            ElMessage({
              message: `${t("trade.text58")}≤${stopProfitEdge.value}`,
              type: "error",
              appendTo: ".businessDemo",
            });
            return;
          }
        }
      }

      if (parseInt(moment().format("YYYYMMDDhhmmss")) > parseInt(data.date)) {
        ElMessage({
          message: t("trade.text106"),
          type: "error",
          appendTo: ".businessDemo",
        });
        return;
      }
      if (openStatus.value == 0) {
        return;
      }
      if (
        traMode.value == "2" &&
        data.listPrice > listPriceMin.value &&
        data.listPrice < listPriceMax.value
      ) {
        ElMessage({
          message: t("trade.text105"),
          type: "error",
          appendTo: ".businessDemo",
        });
        return;
      }
      orderVisible.value = true;
    }

    function limit(v) {
      errorText.value = "";
      let val = v;
      if (val.length > 6) {
        val = val.substring(0, val.length - 1);
      }
      nextTick(() => {
        tradpassword.value = val;
      });
    }
    //关闭弹框
    function orderVisibleClose() {
      errorText.value = "";
      orderVisible.value = false;
      tradpassword.value = "";
    }


    //
    function traModeChange() {
      countListPriceRange();
      countListPrice();
    }

    function setFulltime(time) {
      return time.getTime() + 86400000 < Date.now();
    }

    //快速交易-买
    function fastSell() {
      nowOption.value = "sell";
      traMode.value = "1";
      Object.assign(data, {
        date: "",
        stopProfit: "",
        stopLoss: "",
        listPrice: "",
      });
      countStopProfitRange();
      countListPriceRange();
      countListPrice();
      countDeposit();
      fastShow.value = false;
    }

    //快速交易-卖
    function fastBuy() {
      nowOption.value = "buy";
      traMode.value = "1";
      Object.assign(data, {
        date: "",
        stopProfit: "",
        stopLoss: "",
        listPrice: "",
      });
      countStopProfitRange();
      countListPriceRange();
      countListPrice();
      countDeposit();
      fastShow.value = false;
    }

    //快速交易-关
    function fastClose() {
      fastShow.value = true;
    }
    return {
      nowOption,
      fastClose,
      traMode,
      data,
      changeOption,
      offerData,
      bidData,
      deposit,
      listPriceMin,
      listPriceMax,
      stopLosstEdge,
      stopProfitEdge,
      estimatedProfit,
      estimatedLoss,
      reduce,
      add,
      orderVisible,
      confirm,
      activeSymbol,
      confirmTransaction,
      realTime,
      handCountCheck,
      handCountInput,
      stopProfitInput,
      stopLossInput,
      openStatus,
      forgetPassword,
      disabledDate,
      tradpassword,
      loading,
      limit,
      errorText,
      orderVisibleClose,
      userToken,
      traModeChange,
      setFulltime,
      instantTrading,
      tradeToken,
      fastShow,
      fastSell,
      fastBuy,
    };
  },
};
</script>
<style lang="less">
.businessDemo {
  height: 100%;

  .fast_trading {
    display: flex;
    justify-content: left;
    border-radius: 2px;
    /*no*/
    overflow: hidden;
    font-size: 12px;
    /*no*/
    overflow: visible;

    .fast_sell {
      width: 80px;
      /*no*/
      color: white;
      line-height: 30px;
      /*no*/
      border-radius: 2px 0px 0px 2px;
      /*no*/
      margin-right: 8px;
      /*no*/
      text-align: center;
    }

    .fast_value {
      width: 88px;
      /*no*/
      padding: 0 4px;
      /*no*/
      text-align: center;
      box-shadow: 0px 3px 8px 0px rgba(190, 190, 190, 0.6);
      /*no*/
      border: 1px solid #ebebeb;
      /*no*/
      font-size: 12px;

      /*no*/
      .fuhao {
        width: 10px;
        /*no*/
        font-size: 14px;
        /*no*/
        color: #fb741b;
      }
    }

    .fast_buy {
      width: 80px;
      /*no*/
      color: white;
      line-height: 30px;
      /*no*/
      border-radius: 2px 0px 0px 2px;
      /*no*/
      margin-left: 8px;
      /*no*/
      text-align: center;
    }
  }

  .fast_trading2 {
    position: relative;
    background: @white;
    box-shadow: 0px 5px 20px 4px rgba(136, 136, 136, 0.5);
    /*no*/
    padding: 18px 36px 20px 16px;
    /*no*/
    border-radius: 8px;

    .iconfont {
      font-size: 10px;
      color: #999999;
      position: absolute;
      right: 11px;
      top: 11px;
      cursor: pointer;
    }
  }

  .ant-calendar-picker {
    min-width: 100% !important;
  }

  position: relative;

  .business_btn {
    display: flex;
    justify-content: space-around;

    .business_btn_buy,
    .business_btn_sell {
      width: 130px;
      /*no*/
      height: 24px;
      /*no*/
      line-height: 24px;
      /*no*/
      background: @content-bg-color;
      border-radius: 2px;
      /*no*/
      display: flex;
      justify-content: center;
      color: @text-color-secondary;
      cursor: pointer;
      box-shadow: 0px 3px 8px 0px rgba(190, 190, 190, 0.6);

      /*no*/
      .business_btn_buy_value {
        margin-left: 8px;
        /*no*/

        span {
          font-weight: bolder;
          font-size: 16px;
        }
      }
    }

    .active_btn {
      color: @white;
    }
  }

  .business_form {
    margin-top: 8px;

    .business_form_item,
    .business_form_item_mode {
      display: flex;
      justify-content: space-between;
      padding: 4px 0;

      .business_form_item_lable {
        font-size: 12px;
        color: @text-color-secondary;
        text-align: left;
        line-height: 20px;
        padding-top: 8px !important;
        width: 88px !important;
      }

      .order_expiry_time {
        padding: 0;
      }

      .business_form_item_value {
        font-size: 12px;
        width: 180px;

        input {
          text-align: left;
          font-weight: bold;
          font-size: 12px;
          /*no*/
        }

        .fuhao {
          width: 26px;
          /*no*/
          color: @primary-color;
        }

        .hr {
          width: 1px;
          /*no*/
          height: 14px;
          /*no*/
          margin-top: 1px;
          /*no*/
          background: @border-color-base;
        }

        .jian {
          border-left: 1px solid @border-color-base;
          /*no*/
        }

        .business_form_item_value_bottom {
          color: @text-color-third;
          font-size: 10px;
          /*no*/
          text-align: left;
          margin-top: 4px;
          /*no*/
        }

        .business_form_item_value_estimated {
          /*no*/
        }
      }

      .order_expiry_time {}
    }

    .business_form_item_mode {
      display: flex;
      justify-content: space-between;
    }
  }

  .determine {
    margin-top: 10px;

    .el-button {
      width: 100%;
    }

    .graw {
      background: #aaa;
    }
  }
}

.form_item {
  overflow: hidden;
  margin-bottom: 10px;

  /*no*/
  .form_item_lable {
    font-size: 14px;
    /*no*/
    float: left;
    width: 50%;
    color: @text-color-secondary;
    font-weight: 500;
  }

  .form_item_value {
    font-weight: 500;
  }
}

.tran_password {
  .tran_password_inp {
    margin-top: 26px;
    /*no*/
    position: relative;

    .errorText {
      position: absolute;
      top: -18px;
      /*no*/
      color: @red;
      font-size: 12px;
      /*no*/
    }
  }

  .forget {
    color: @primary-color;
    font-size: 12px;
    /*no*/
    float: right;
    margin-top: 8px;
    /*no*/
  }
}

.confirm_transaction {
  margin-top: 30px;
}

.tra_password_modal {
  .tip {
    background: #feeeeb;
    height: 32px;
    line-height: 32px;
    color: @primary-color;
    text-align: center;
    margin-bottom: 16px;
  }

  .tra_password_input {
    margin-bottom: 26px;
  }
}
</style>
<style lang="less">
.businessDemo {
  .el-input__suffix {
    right: 0;
  }

  .el-input-group__prepend {
    padding: 0;
    background: white;
    border: none;
  }

  .fast_value {
    .el-input__inner {
      border: none;
      padding: 0;
      text-align: center;
    }

    .el-input--small {
      font-size: 12px;
      /*no*/
      height: 28px
        /*no*/
    }

    .el-input-group__prepend {
      box-shadow: none;
    }

    .el-input__wrapper {
      box-shadow: none;
    }
  }
}
</style>
<style lang="less">
.businessDemo {
  .el-input__wrapper {
    padding-right: 0;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__wrapper {
    width: 180px;
  }
}
</style>